// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Plan_wrapper__3hpPH","year":"Plan_year__3ydkH","plan":"Plan_plan__275HD","text":"Plan_text__2jBvh"};